import React from 'react';
import postAppointment from '../api/postAppointment';
import { AppointmentParams } from '../types/AppontmentParams';
import { PostAppointmentResponse } from '../types/PostAppointmentResponse';

const usePostAppointment = (): [PostAppointmentResponse | null, (params: Partial<AppointmentParams>) => void] => {
  const [postAppointmentResponse, setPostAppointmentResponse] = React.useState<PostAppointmentResponse | null>(null);
  const regAppointment = React.useCallback(
    ({
      appointmentOnBehalfOf,
      appointmentTypeId,
      dateOfBirth,
      emailAddress,
      endDateTime,
      firstName,
      gender,
      houseNumber,
      lastName,
      note,
      phoneNumber,
      postcode,
      roomId,
      shopNumber,
      startDateTime,
      utmCampaign,
      utmContent,
      utmMedium,
      utmSource,
      utmTerm,
      receiveNewsletters,
    }: Partial<AppointmentParams>) => {
      if (
        appointmentOnBehalfOf &&
        appointmentTypeId &&
        dateOfBirth &&
        emailAddress &&
        endDateTime &&
        firstName &&
        gender &&
        houseNumber &&
        lastName &&
        postcode &&
        roomId &&
        shopNumber &&
        startDateTime
      ) {
        postAppointment({
          appointmentOnBehalfOf,
          appointmentTypeId,
          dateOfBirth,
          emailAddress,
          endDateTime,
          firstName,
          gender,
          houseNumber,
          lastName,
          newReturnUrl: true,
          note,
          phoneNumber,
          postcode,
          receiveNewsletters: receiveNewsletters || false,
          roomId,
          shopNumber,
          startDateTime,
          utmCampaign,
          utmContent,
          utmMedium,
          utmSource,
          utmTerm,
        })
          .then((res) => setPostAppointmentResponse(res.success ? res.payload : null))
          .catch(() => setPostAppointmentResponse(null));
      } else {
        console.warn('Appointment data missing');
        setPostAppointmentResponse(null);
      }
    },
    [],
  );

  return [postAppointmentResponse, regAppointment];
};

export default usePostAppointment;
